<template>
  <div>
    {{ debits }}
    <br />------<br />
    <c-table ref="table" :rows="rows" :headers="headers" expandable :checkable="false">
      
      <div slot="toolbar">

        <v-btn 
        round
        dark
        color="teal accent-3"
        @click="addItem">
        <v-icon>add</v-icon>
          Add Item
        </v-btn>

        <v-btn icon @click="autoCalculate">
          <v-icon>android</v-icon>
        </v-btn>

        <v-btn icon @click="clearDebits">
          <v-icon>delete</v-icon>
        </v-btn>

      </div>

      <header-row
      slot="row" 
      :row="sprps.row" 
      slot-scope="sprps" 
      :sprps="sprps"
      :required="required"
      :debitsFrozen="debitsFrozen"
      :debits="debits">
      </header-row>
      <expand-row 
      slot="compact-row" 
      :row="sprps.row" 
      slot-scope="sprps" 
      :sprps="sprps"
      :required="required"
      :debitsFrozen="debitsFrozen"
      :debits="debits">
      </expand-row>
    </c-table>
  </div>
</template>

<script>
import HeaderRow from './HeaderRow'
import ExpandRow from './ExpandRow'
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: {
    invIDs: { // [inventory_item_id, ...]
      type: Array,
      default: () => {
        return []
      }
    },
    debits: { // [{inventory_id: 666}, ...]
      type: Object,
      default: () => {
        return {}
      }
    },
    // this is the debits already in another table
    debitsFrozen: { // [{inventory_item_id, archive_id, quantity}, ...]
      type: Array,
      default: () => {
        return []
      }
    },
    required: { // {inv_item_id: quantity, inv_item_id: quantity}
      type: Object,
      default: () => {
        return {}
      }
    },
    automationControls: {
      type: Object,
      default: () => {
        return {
          expiryPeriod: 'Months',
          expiryInt: 6,
          batchOrder: 'Expiring first'
        }
      }
    }
  },
  components: {
    'header-row': HeaderRow,
    'expand-row': ExpandRow
  },
  data () {
    return {
      rows: [],
      headers: ['Item', 'Total in stock', 'Quantity required', 'Quantity used']
    }
  },
  computed: {
    ...mapGetters({
      getInventoryOf: 'db/inventory/getInventoryOf',
      getArchiveExpiryInfo: 'db/inventoryArchive/getExpiryInfo'
    })
  },
  methods: {
    addItem () {
      // 5
    },
    clearDebits () {
      Object.values(this.debits).forEach(invItemDebit => {
        Object.keys(invItemDebit).forEach(archiveID => {
          invItemDebit[archiveID] = 0
        })
      })
    },
    autoCalculate () {
      this.clearDebits()

      this.invIDs.forEach(invIDRow => {
        var id = invIDRow.inventory_item_id
        var required = this.required[id]
        var inventory = this.getInventoryOf(id)
        /* var reserved = this.debitsFrozen.filter(item => {
          return item.inventory_item_id === id
        }) */
        // sort inventory
        inventory.sort((a, b) => {
          var aExpiry = this.getArchiveExpiryInfo(a.archive_id).fromNow
          var bExpiry = this.getArchiveExpiryInfo(b.archive_id).fromNow
          let orderByExpires = this.automationControls.batchOrder === 'Expiring first' ? aExpiry - bExpiry : bExpiry - aExpiry
          return orderByExpires
        })
        inventory.forEach(invItem => {
          if (required <= 0) {
            return
          }
          // skip items with expiry sooner than permitted
          if (this.getArchiveExpiryInfo(invItem.archive_id).fromNow < this.automationControls.expiry) {
            return
          }
          // do debits
          if (invItem.quantity > required) {
            Vue.set(this.debits[id], invItem.archive_id, required)
            required = 0
          }
          if (invItem.quantity <= required) {
            Vue.set(this.debits[id], invItem.archive_id, invItem.quantity)
            required -= invItem.quantity
          }
        })
      })
    }
  },
  mounted () {
    this.rows = JSON.parse(JSON.stringify(this.invIDs))
    // add all inventory_item_ids from debitsFrozen if not in this.rows
    for (var row of this.debitsFrozen) {
      var match = this.rows.find(item => item.inventory_item_id === row.inventory_item_id)
      if (!match) {
        this.rows.push(row.inventory_item_id)
        console.log('item not found')
        console.log(row)
      }
    }
    this.rows.map(item => {
      item.tempID = this.$refs.table.getNewID()
      return item
    })
    this.rows.forEach(item => {
      Vue.set(this.debits, item.inventory_item_id, {})
    })
    // if debitsFrozen prepopulate values
    for (row of this.debitsFrozen) {
      if (!this.debits[row.inventory_item_id]) {
        Vue.set(this.debits, row.inventory_item_id, {})
      }
      Vue.set(this.debits[row.inventory_item_id], row.archive_id, row.quantity)
    }
  }
}
</script>
